import { Box, Grid } from "@material-ui/core";
import TokenHealthChart from "./TokenHealthChart";
import TokenHistoryChart from "./TokenHistoryChart";

export default function HealthOverview({ historyData, token, ...props }) {
  return (
    <Box {...props}>
      <Grid container>
        <Grid item md={6} xs={12}>
          <TokenHealthChart token={token} />
        </Grid>
        <Grid item md={6} xs={12}>
          <TokenHistoryChart historyData={historyData} />
        </Grid>
      </Grid>
    </Box>
  );
}
